import {api} from 'services/api';
import {ObjectId} from 'types/object-id';
import {IConclusion, ITeam} from 'types/project';
import {ResponseData} from 'types/response-data';

const getProjectTeam = api.injectEndpoints({
  endpoints: builder => ({
    getProjectTeam: builder.query<Response, Request>({
      query: params => {
        return {
          method: 'GET',
          url: `projects/${params.id}/assistants`,
        };
      },
    }),
  }),
});

type Request = {
  id?: ObjectId;
};

type Response = ResponseData<Array<ITeam>>;

export const {useGetProjectTeamQuery} = getProjectTeam;
